import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    max-width: 12.7em;
    height: 100%;
    padding-bottom: 2em;

    .categories-container {
        position: sticky;
        top: 10em;

        .categories-list {
            .category {
                padding: .5em 1.33em;
                border: .01em solid #000000;
                text-align: center;
                font-size: 1.1em;

                &:not(:last-child) {
                    border-bottom: 0;
                }

                &.active {
                    background-color: #10F5B0;
                    font-weight: 700;
                }

                .categories-link {
                    text-decoration: none;
                    color: #000000;
                }
            }
        }
    }

    .categories-container-mobile {
        display: none;
    }

    @media all and (max-width:${vars.tabletL}) {
        width: 100%;

        .categories-container {
            display: none;
        }

        .categories-container-mobile {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;

            .categories-list-mobile {
                display: flex;
                align-items: center;
                justify-content: center;

                .layout-slick {
                    max-width: 82vw;

                    .slick-slider {
                        .slick-prev {
                        }

                        .slick-list {
                            .slick-track {
                                .slick-slide {
                                    div {
                                        .category-mobile {
                                            border: .01em solid #000000;
                                            text-align: center;
                                            padding: .3em 1em;
                                            font-size: 1em;

                                            &:not(:last-child) {
                                                border-bottom: .01em solid #000000;
                                            }

                                            &.active {
                                                background-color: #10F5B0;
                                                font-weight: 700;
                                            }

                                            .categories-link-mobile {
                                                text-decoration: none;
                                                color: #000000;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .slick-next {
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width:${vars.mobileL}) {
        .categories-container-mobile {
            .categories-list-mobile {
                .layout-slick {
                    max-width: 86vw;
                }
            }
        }
    }
`;